'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/has/src/index.js
// module id = IpzJ
// module chunks = 0